import React from 'react';

interface BillingInfoBoxProps {
  /** 請求先名 */
  name: string;
  /** 整形済み住所文字列（改行コード \n で区切られる） */
  address: string;
}

/**
 * 請求先情報Box
 *
 * 修繕履歴画面（InquiryDetail 作業完了ステータス）で、
 * 支払方法=bill の場合に表示する（顧客区分は問わない。2026-08-08 に個人限定を撤廃）。
 *
 * 表示条件判定は呼び出し側が行う。本コンポーネントは表示のみを担当する。
 * ただし旧仕様（法人スキップ）期間に登録されたレコードは請求先名・住所が空のため、
 * 全項目空のときは見出しだけのカードを出さないよう非表示にする。
 */
export const BillingInfoBox: React.FC<BillingInfoBoxProps> = ({ name, address }) => {
  if (!name && !address) {
    return null;
  }
  return (
    <div className="info-box">
      <h3 className="info-box-title">請求先情報</h3>
      {name && (
        <div className="info-row">
          <p className="info-label">請求先名</p>
          <div className="info-value-wrap">
            <p className="info-value">{name}</p>
          </div>
        </div>
      )}
      {address && (
        <div className="info-row">
          <p className="info-label">請求先住所</p>
          <div className="info-value-wrap">
            <p
              className="info-value"
              data-testid="billing-info-address"
              style={{ whiteSpace: 'pre-line' }}
            >
              {address}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
